module.exports = __webpack_public_path__ + "static/media/delete-item.f1a25e02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/delete-item.svg
// module id = 1680
// module chunks = 0